module.exports = "/assets/883271443badbbf99d2a57417b557a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CA.png
// module id = 2386
// module chunks = 0